import { Map } from 'immutable';

import {
  DELETE_CAMERA_SCHEDULE,
  RECEIVE_CAMERA_SCHEDULES,
  REQUEST_CAMERA_SCHEDULE,
} from '@sophocles/entities/CameraSchedule/cameraScheduleActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CAMERA_SCHEDULES: // Read
      return state.merge(action.cameraSchedules);
    case DELETE_CAMERA_SCHEDULE: // Socket delete
      return state.delete(action.cameraSchedule.toString());
    case REQUEST_CAMERA_SCHEDULE:
    default:
      return state;
  }
}

export function cameraScheduleReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_CAMERA_SCHEDULES:
    case DELETE_CAMERA_SCHEDULE:
    case REQUEST_CAMERA_SCHEDULE:
      return getState(state, action);
    default:
      return state;
  }
}
